/*
window.Vue = require('vue');

 Vue.component('font-awesome-icon', FontAwesomeIcon);


import {SessionList} from './components/SessionList';
import {DummyClock} from './components/DummyClock';



import {RedeemTicket} from './components/RedeemTicket';

import {VideoPlayer} from './components/Videojs';

import {VueVimeo} from './components/VueVimeo';

import {VueAutocomplete} from './components/VueAutocomplete';
import {SessionResponsive} from './components/SessionResponsive';
import {AdvertDisplay} from './components/AdvertDisplay';
import {ZoomOrgs} from './components/ZoomOrgs';
import {Flyout} from './components/ui/Flyout';

import {HeroIcon} from './components/heroicons/HeroIconBase';

import {HeroMoon} from './components/heroicons/src/Moon';
*/

import AdvertDisplay from './components/AdvertDisplay';
import UppyWrapper from './components/forms/UppyWrapper';
import EventbriteTicket from './components/EventbriteTicket';
import CountdownTimer from "./components/CountdownTimer";
import {createApp} from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core';
//import { faUserSecret as falUserSecret } from '@fortawesome/pro-light-svg-icons';

import {faCoffee as fasCoffee} from '@fortawesome/pro-solid-svg-icons'

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

library.add(fasCoffee);

import FavoriteSession from './components/FavoriteSession';

import Tiptap from './components/forms/TipTap';

import OrganizationWidgets from './components/organization/Widgets';
import OrganizationWidget from './components/organization/Widget';
/*
import Tiptap3 from './components/forms/TipTap3';

import SelectMenuSupportedText from "./components/ui/SelectMenuSupportedText";
*/

import DoubleNav from "./components/tailwindui/DoubleNav";

import SessionStatus from './components/SessionStatus';

import VueYoutube from './components/VueYoutube';

import SessionResponsiveOld from './components/SessionResponsive';

import SessionResponsive from './components/session/Responsive';

import SessionLive from './components/SessionLive';

import RedeemTicket from "./components/RedeemTicket";

import MeetupStatus from "./components/MeetupStatus";

import SessionLiveLocation from "./components/SessionLiveLocation.vue";
/*
import DateTimePicker from './components/forms/DateTimePicker'
import ExampleComponent from './components/ExampleComponent';

Vue.component('font-awesome-icon', FontAwesomeIcon);

import TipTapUploader from "./components/forms/TipTapUploader/TipTapUploader";
*/

/** Apollo
 * https://github.com/laracasts/lc-vue-graphql/blob/9bbcdf5a4d9471b7f438fffc568a0a2506d3cfab/src/main.js
 * https://laracasts.com/series/graphql-with-laravel-and-vue/episodes/7
 * https://vueschool.io/articles/vuejs-tutorials/infinite-scrolling-in-vue-with-apollo/
 */

import {
    ApolloClient,
    createHttpLink,
    InMemoryCache,
} from '@apollo/client/core';

import {createApolloProvider} from '@vue/apollo-option';

import VueApolloComponents from "@vue/apollo-components";

const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: '/graphql',
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
});

import IoTest from './components/io/test';

createApp(
    {
        components: {

            IoTest,
            AdvertDisplay,
            MeetupStatus,
            FavoriteSession,
            DoubleNav,
            library,
            FontAwesomeIcon,
            SessionStatus,
            VueYoutube,
            SessionResponsive,
            SessionLive,
            EventbriteTicket,
            CountdownTimer,
            RedeemTicket,
            Tiptap,
            UppyWrapper,
            OrganizationWidgets,
            OrganizationWidget,
            SessionResponsiveOld,
            SessionLiveLocation,
            /*
            DateTimePicker,
            SelectMenuSupportedText,
            TipTapUploader,
            Tiptap3,
            SessionList,
            DummyClock,
            SessionLive,
            SessionStatus,
            EventbriteTicket,
            VideoPlayer,
            VueAutocomplete,
            SessionResponsive,
            AdvertDisplay,
            ZoomOrgs,
            Flyout
            */
        }
    }
).use(apolloProvider).use(VueApolloComponents).mount('#app');

